import React from 'react'

import { ActivityType } from 'modules/accountActivity/domain'
import { ReactComponent as Conversation } from 'svgs/activities/Conversation.svg'
import { ReactComponent as Email } from 'svgs/activities/Email.svg'
import { ReactComponent as Meeting } from 'svgs/activities/Meeting.svg'
import { ReactComponent as SiteVisit } from 'svgs/activities/SiteVisit.svg'
import { ReactComponent as Video } from 'svgs/activities/Video.svg'

interface ActivityIconProps {
  activityType: ActivityType
  className?: string
}

const ActivityIcon: React.FC<ActivityIconProps> = ({ activityType, className }) => {
  let Icon = SiteVisit

  if (activityType === ActivityType.CONVERSATION) {
    Icon = Conversation
  }

  if (
    [ActivityType.EMAIL_CLICK, ActivityType.EMAIL_OPEN, ActivityType.EMAIL_SEND].includes(
      activityType
    )
  ) {
    Icon = Email
  }

  if (
    [
      ActivityType.MEETING_BOOKED,
      ActivityType.MEETING_CANCELED,
      ActivityType.MEETING_RESCHEDULED
    ].includes(activityType)
  ) {
    Icon = Meeting
  }

  if (activityType === ActivityType.VIDEO) {
    Icon = Video
  }

  return (
    <span className={className}>
      <Icon height="26" width="26" viewBox="0 0 26 26" />
    </span>
  )
}

export default ActivityIcon